import { throttle as E } from "lodash-es";
import F from "./BaseRenderer.js";
import { createWebGL2WarpedMapFactory as I } from "../maps/WebGL2WarpedMap.js";
import D from "../tilecache/CacheableWorkerImageDataTile.js";
import { squaredDistance as x, hexToFractionalRgb as f, maxOfNumberOrUndefined as P } from "@allmaps/stdlib";
import { supportedDistortionMeasures as V } from "@allmaps/transform";
import { red as R, darkblue as G, green as y, yellow as N, black as H } from "@allmaps/tailwind";
import { WarpedMapEvent as m, WarpedMapEventType as T } from "../shared/events.js";
import { multiplyTransform as O, transformToMatrix4 as u, invertTransform as z } from "../shared/matrix.js";
import { createShader as p, createProgram as l } from "../shared/webgl2.js";
import _ from "../shaders/map/vertex-shader.glsl.js";
import C from "../shaders/map/fragment-shader.glsl.js";
import S from "../shaders/lines/vertex-shader.glsl.js";
import A from "../shaders/lines/fragment-shader.glsl.js";
import W from "../shaders/points/vertex-shader.glsl.js";
import U from "../shaders/points/fragment-shader.glsl.js";
const q = 200, X = {
  leading: !0,
  trailing: !0
}, j = 50, B = {
  leading: !0,
  trailing: !0
}, v = 1, w = 1, k = 0, $ = 0.7, Y = 5, b = 750;
class ft extends F {
  gl;
  mapProgram;
  linesProgram;
  pointsProgram;
  previousSignificantViewport;
  opacity = v;
  saturation = w;
  renderOptions = {};
  lastAnimationFrameRequestId;
  animating = !1;
  transformationTransitionStart;
  animationProgress = 0;
  disableRender = !1;
  throttledPrepareRenderInternal;
  throttledChanged;
  /**
   * Creates an instance of WebGL2Renderer.
   *
   * @constructor
   * @param {WebGL2RenderingContext} gl - WebGL 2 rendering context
   * @param {WebGL2RendererOptions} options - options
   */
  constructor(t, r) {
    const e = p(
      t,
      t.VERTEX_SHADER,
      _
    ), o = p(
      t,
      t.FRAGMENT_SHADER,
      C
    ), i = p(
      t,
      t.VERTEX_SHADER,
      S
    ), s = p(
      t,
      t.FRAGMENT_SHADER,
      A
    ), n = p(
      t,
      t.VERTEX_SHADER,
      W
    ), a = p(
      t,
      t.FRAGMENT_SHADER,
      U
    ), d = l(t, e, o), c = l(
      t,
      i,
      s
    ), h = l(
      t,
      n,
      a
    );
    super(
      D.createFactory(),
      I(t, d, c, h),
      r
    ), this.gl = t, this.mapProgram = d, this.linesProgram = c, this.pointsProgram = h, t.deleteShader(e), t.deleteShader(o), t.deleteShader(e), t.deleteShader(o), t.deleteShader(e), t.deleteShader(o), t.disable(t.DEPTH_TEST), this.addEventListeners(), this.throttledPrepareRenderInternal = E(
      this.prepareRenderInternal.bind(this),
      q,
      X
    ), this.throttledChanged = E(
      this.changed.bind(this),
      j,
      B
    );
  }
  initializeWebGL(t) {
    const r = p(
      t,
      t.VERTEX_SHADER,
      _
    ), e = p(
      t,
      t.FRAGMENT_SHADER,
      C
    ), o = p(
      t,
      t.VERTEX_SHADER,
      S
    ), i = p(
      t,
      t.FRAGMENT_SHADER,
      A
    ), s = p(
      t,
      t.VERTEX_SHADER,
      W
    ), n = p(
      t,
      t.FRAGMENT_SHADER,
      U
    ), a = l(t, r, e), d = l(
      t,
      o,
      i
    ), c = l(
      t,
      s,
      n
    );
    this.gl = t, this.mapProgram = a, this.linesProgram = d, this.pointsProgram = c, t.disable(t.DEPTH_TEST);
    for (const h of this.warpedMapList.getWarpedMaps())
      h.initializeWebGL(a, d, c);
  }
  /**
   * Get the opacity of the renderer
   *
   * @returns {(number | undefined)}
   */
  getOpacity() {
    return this.opacity;
  }
  /**
   * Set the opacity of the renderer
   *
   * @param {number} opacity - opacity to set
   */
  setOpacity(t) {
    this.opacity = t;
  }
  /**
   * Reset the opacity of the renderer
   */
  resetOpacity() {
    this.opacity = v;
  }
  /**
   * Get the opacity of a map
   *
   * @param {string} mapId - ID of the map
   * @returns {(number | undefined)}
   */
  getMapOpacity(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    if (r)
      return r.opacity;
  }
  /**
   * Set the opacity of a map
   *
   * @param {string} mapId - ID of the map
   * @param {number} opacity - opacity to set
   */
  setMapOpacity(t, r) {
    const e = this.warpedMapList.getWarpedMap(t);
    e && (e.opacity = Math.min(Math.max(r, 0), 1));
  }
  /**
   * Rreset the opacity of a map
   *
   * @param {string} mapId - ID of the map
   */
  resetMapOpacity(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && (r.opacity = v);
  }
  /**
   * Get the remove color options of the renderer
   *
   * @returns {(Partial<RemoveColorOptions> | undefined)}
   */
  getRemoveColorOptions() {
    return this.renderOptions.removeColorOptions;
  }
  /**
   * Set the remove color options of the renderer
   *
   * @param {RemoveColorOptions} removeColorOptions
   */
  setRemoveColorOptions(t) {
    this.renderOptions.removeColorOptions = t;
  }
  /**
   * Reset the remove color options of the renderer
   */
  resetRemoveColorOptions() {
    this.renderOptions.removeColorOptions = void 0;
  }
  /**
   * Get the remove color options of a map
   *
   * @param {string} mapId - ID of the map
   * @returns {(Partial<RemoveColorOptions> | undefined)}
   */
  getMapRemoveColorOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    if (r)
      return r.renderOptions.removeColorOptions;
  }
  /**
   * Set the remove color options of a map
   *
   * @param {string} mapId - ID of the map
   * @param {RemoveColorOptions} removeColorOptions - the 'remove color options' to set
   */
  setMapRemoveColorOptions(t, r) {
    const e = this.warpedMapList.getWarpedMap(t);
    e && (e.renderOptions.removeColorOptions = r);
  }
  /**
   * Reset the remove color options of a map
   *
   * @param {string} mapId - ID of the map
   */
  resetMapRemoveColorOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && (r.renderOptions.removeColorOptions = void 0);
  }
  /**
   * Get the colorize options of the renderer
   *
   * @returns {(Partial<ColorizeOptions> | undefined)}
   */
  getColorizeOptions() {
    return this.renderOptions.colorizeOptions;
  }
  /**
   * Set the colorize options of the renderer
   *
   * @param {ColorizeOptions} colorizeOptions - the colorize options to set
   */
  setColorizeOptions(t) {
    this.renderOptions.colorizeOptions = t;
  }
  /**
   * Reset the colorize options of the renderer
   */
  resetColorizeOptions() {
    this.renderOptions.colorizeOptions = void 0;
  }
  /**
   * Get the colorize options of a map
   *
   * @param {string} mapId - ID of the map
   * @returns {(Partial<ColorizeOptions> | undefined)}
   */
  getMapColorizeOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    if (r)
      return r.renderOptions.colorizeOptions;
  }
  /**
   * Set the colorize options of a map
   *
   * @param {string} mapId - ID of the map
   * @param {ColorizeOptions} colorizeOptions - the colorize options to set
   */
  setMapColorizeOptions(t, r) {
    const e = this.warpedMapList.getWarpedMap(t);
    e && (e.renderOptions.colorizeOptions = r);
  }
  /**
   * Reset the colorize options of a map
   *
   * @param {string} mapId - ID of the map
   */
  resetMapColorizeOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && (r.renderOptions.colorizeOptions = void 0);
  }
  /**
   * Get the grid options of the renderer
   *
   * @returns {(Partial<GridOptions> | undefined)}
   */
  getGridOptions() {
    return this.renderOptions.gridOptions;
  }
  /**
   * Set the grid options of the renderer
   *
   * @param {GridOptions} gridOptions - the grid options to set
   */
  setGridOptions(t) {
    this.renderOptions.gridOptions = t;
  }
  /**
   * Reset the grid options of the renderer
   */
  resetGridOptions() {
    this.renderOptions.gridOptions = void 0;
  }
  /**
   * Get the grid options of a map
   *
   * @param {string} mapId - ID of the map
   * @returns {(Partial<GridOptions> | undefined)}
   */
  getMapGridOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    if (r)
      return r.renderOptions.gridOptions;
  }
  /**
   * Set the grid options of a map
   *
   * @param {string} mapId - ID of the map
   * @param {GridOptions} gridOptions - the grid options to set
   */
  setMapGridOptions(t, r) {
    const e = this.warpedMapList.getWarpedMap(t);
    e && (e.renderOptions.gridOptions = r);
  }
  /**
   * Reset the grid options of a map
   *
   * @param {string} mapId - ID of the map
   */
  resetMapGridOptions(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && (r.renderOptions.gridOptions = void 0);
  }
  /**
   * Get the saturation of the renderer
   *
   * @returns {number}
   */
  getSaturation() {
    return this.saturation;
  }
  /**
   * Set the saturation of the renderer
   *
   * 0 - grayscale, 1 - original colors
   *
   * @param saturation - the satuation to set
   */
  setSaturation(t) {
    this.saturation = t;
  }
  /**
   * Reset the satuation of the renderer
   */
  resetSaturation() {
    this.saturation = w;
  }
  /**
   * Get the saturation of a map
   *
   * @param {string} mapId - ID of the map
   * @returns {(number | undefined)}
   */
  getMapSaturation(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    if (r)
      return r.saturation;
  }
  /**
   * Set the saturation of a map
   *
   * 0 - grayscale, 1 - original colors
   *
   * @param mapId - ID of the map
   * @param saturation - the saturation to set
   */
  setMapSaturation(t, r) {
    const e = this.warpedMapList.getWarpedMap(t);
    e && (e.saturation = r);
  }
  /**
   * Reset the saturation of a map
   *
   * @param {string} mapId - ID of the map
   */
  resetMapSaturation(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && (r.saturation = w);
  }
  /**
   * Render the map for a given viewport
   *
   * @param {Viewport} viewport - the current viewport
   */
  render(t) {
    this.disableRender || (this.viewport = t, this.loadMissingImageInfosInViewport(), this.someImageInfosInViewport() && this.throttledPrepareRenderInternal(), this.renderInternal());
  }
  clear() {
    this.warpedMapList.clear(), this.mapsInViewport = /* @__PURE__ */ new Set(), this.mapsWithRequestedTilesForViewport = /* @__PURE__ */ new Set(), this.gl.clear(this.gl.DEPTH_BUFFER_BIT | this.gl.COLOR_BUFFER_BIT), this.tileCache.clear();
  }
  cancelThrottledFunctions() {
    this.throttledPrepareRenderInternal.cancel(), this.throttledChanged.cancel();
  }
  destroy() {
    this.cancelThrottledFunctions();
    for (const t of this.warpedMapList.getWarpedMaps())
      this.removeEventListenersFromWebGL2WarpedMap(t);
    this.removeEventListeners(), super.destroy(), this.gl.deleteProgram(this.mapProgram), this.gl.deleteProgram(this.linesProgram), this.gl.deleteProgram(this.pointsProgram);
  }
  updateMapsForViewport(t) {
    const { mapsEnteringViewport: r, mapsLeavingViewport: e } = super.updateMapsForViewport(t);
    for (const o of r) {
      const i = this.warpedMapList.getWarpedMap(o);
      if (!i || !this.viewport)
        break;
      i.updateVertexBuffers(
        this.viewport.projectedGeoToClipTransform
      );
    }
    return { mapsEnteringViewport: r, mapsLeavingViewport: e };
  }
  prepareRenderInternal() {
    this.requestFetchableTiles();
  }
  shouldRequestFetchableTiles() {
    if (!this.viewport || this.animating)
      return !1;
    if (this.previousSignificantViewport) {
      const t = [];
      for (let e = 0; e < 4; e++)
        t.push(
          x(
            this.previousSignificantViewport.projectedGeoRectangle[e],
            this.viewport.projectedGeoRectangle[e]
          ) / Math.pow(this.viewport.projectedGeoPerViewportScale, 2)
        );
      const r = Math.max(...t);
      return r === 0 ? !0 : r > Math.pow(Y, 2) ? (this.previousSignificantViewport = this.viewport, !0) : !1;
    } else
      return this.previousSignificantViewport = this.viewport, !0;
  }
  shouldAnticipateInteraction() {
    return !0;
  }
  renderInternal() {
    if (!this.viewport)
      return;
    const t = this.gl;
    t.viewport(0, 0, t.canvas.width, t.canvas.height), t.enable(t.BLEND), t.blendFunc(t.ONE, t.ONE_MINUS_SRC_ALPHA), this.renderMapsInternal();
  }
  renderMapsInternal() {
    if (this.viewport) {
      this.setMapProgramUniforms();
      for (const t of this.mapsWithRequestedTilesForViewport) {
        const r = this.warpedMapList.getWarpedMap(t);
        if (!r)
          continue;
        this.setMapProgramRenderOptionsUniforms(
          this.renderOptions,
          r.renderOptions
        ), this.setMapProgramMapUniforms(r);
        const e = r.resourceTrianglePoints.length, o = this.gl.TRIANGLES, i = 0;
        this.gl.bindVertexArray(r.mapVao), this.gl.drawArrays(o, i, e);
      }
    }
  }
  renderLinesInternal() {
    this.setLinesProgramUniforms();
    for (const t of this.mapsInViewport) {
      const r = this.warpedMapList.getWarpedMap(t);
      if (!r)
        continue;
      this.setLinesProgramMapUniforms(r);
      const e = r.lineLayers.reduce(
        (s, n) => s + n.projectedGeoLines.length,
        0
      ) * 6, o = this.gl.TRIANGLES, i = 0;
      this.gl.bindVertexArray(r.linesVao), this.gl.drawArrays(o, i, e);
    }
  }
  renderPointsInternal() {
    this.setPointsProgramUniforms();
    for (const t of this.mapsInViewport) {
      const r = this.warpedMapList.getWarpedMap(t);
      if (!r)
        continue;
      this.setPointsProgramMapUniforms(r);
      const e = r.pointLayers.reduce(
        (s, n) => s + n.projectedGeoPoints.length,
        0
      ), o = this.gl.POINTS, i = 0;
      this.gl.bindVertexArray(r.pointsVao), this.gl.drawArrays(o, i, e);
    }
  }
  setMapProgramUniforms() {
    const t = this.mapProgram, r = this.gl;
    r.useProgram(t);
    const e = r.getUniformLocation(t, "u_debug");
    r.uniform1f(e, 0);
    const o = r.getUniformLocation(
      t,
      "u_animationProgress"
    );
    r.uniform1f(o, this.animationProgress);
    const i = r.getUniformLocation(
      t,
      "u_colorDistortion00"
    );
    r.uniform4f(i, ...f(R), 1);
    const s = r.getUniformLocation(
      t,
      "u_colorDistortion01"
    );
    r.uniform4f(s, ...f(G), 1);
    const n = r.getUniformLocation(
      t,
      "u_colorDistortion1"
    );
    r.uniform4f(n, ...f(y), 1);
    const a = r.getUniformLocation(
      t,
      "u_colorDistortion2"
    );
    r.uniform4f(a, ...f(N), 1);
    const d = r.getUniformLocation(
      t,
      "u_colorDistortion3"
    );
    r.uniform4f(d, ...f(R), 1);
    const c = r.getUniformLocation(t, "u_colorGrid");
    r.uniform4f(c, ...f(H), 1);
  }
  setMapProgramRenderOptionsUniforms(t, r) {
    const e = this.gl, o = this.mapProgram;
    e.useProgram(o);
    const i = {
      removeColorOptions: {
        color: r.removeColorOptions?.color || t.removeColorOptions?.color,
        hardness: P(
          r.removeColorOptions?.hardness,
          t.removeColorOptions?.hardness
        ),
        threshold: P(
          r.removeColorOptions?.threshold,
          t.removeColorOptions?.threshold
        )
      },
      colorizeOptions: {
        ...t.colorizeOptions,
        ...r.colorizeOptions
      },
      gridOptions: {
        ...t.gridOptions,
        ...r.gridOptions
      }
    }, s = i.removeColorOptions?.color, n = e.getUniformLocation(o, "u_removeColor");
    if (e.uniform1f(n, s ? 1 : 0), s) {
      const g = e.getUniformLocation(
        o,
        "u_removeColorOptionsColor"
      );
      e.uniform3fv(g, s);
      const M = e.getUniformLocation(
        o,
        "u_removeColorOptionsThreshold"
      );
      e.uniform1f(
        M,
        i.removeColorOptions?.threshold || k
      );
      const L = e.getUniformLocation(
        o,
        "u_removeColorOptionsHardness"
      );
      e.uniform1f(
        L,
        i.removeColorOptions?.hardness || $
      );
    }
    const a = i.colorizeOptions?.color, d = e.getUniformLocation(o, "u_colorize");
    if (e.uniform1f(d, a ? 1 : 0), a) {
      const g = e.getUniformLocation(
        o,
        "u_colorizeOptionsColor"
      );
      e.uniform3fv(g, a);
    }
    const c = i.gridOptions?.enabled, h = e.getUniformLocation(o, "u_grid");
    e.uniform1f(h, c ? 1 : 0);
  }
  setMapProgramMapUniforms(t) {
    if (!this.viewport)
      return;
    const r = this.gl, e = this.mapProgram;
    r.useProgram(e);
    const o = O(
      this.viewport.projectedGeoToClipTransform,
      t.invertedRenderTransform
    ), i = r.getUniformLocation(
      e,
      "u_renderTransform"
    );
    r.uniformMatrix4fv(
      i,
      !1,
      u(o)
    );
    const s = r.getUniformLocation(e, "u_opacity");
    r.uniform1f(s, this.opacity * t.opacity);
    const n = r.getUniformLocation(e, "u_saturation");
    r.uniform1f(
      n,
      this.saturation * t.saturation
    );
    const a = r.getUniformLocation(e, "u_distortion");
    r.uniform1f(a, t.distortionMeasure ? 1 : 0);
    const d = r.getUniformLocation(
      e,
      "u_distortionOptionsdistortionMeasure"
    );
    r.uniform1i(
      d,
      t.distortionMeasure ? V.indexOf(t.distortionMeasure) : 0
    );
    const c = r.getUniformLocation(
      e,
      "u_scaleFactorForViewport"
    ), h = t.tileZoomLevelForViewport ? t.tileZoomLevelForViewport.scaleFactor : 1;
    r.uniform1i(c, h);
    const g = r.getUniformLocation(
      e,
      "u_cachedTilesTextureArray"
    );
    r.uniform1i(g, 0), r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D_ARRAY, t.cachedTilesTextureArray);
    const M = r.getUniformLocation(
      e,
      "u_cachedTilesResourceOriginPointsAndDimensionsTexture"
    );
    r.uniform1i(M, 1), r.activeTexture(r.TEXTURE1), r.bindTexture(
      r.TEXTURE_2D,
      t.cachedTilesResourceOriginPointsAndDimensionsTexture
    );
    const L = r.getUniformLocation(
      e,
      "u_cachedTilesScaleFactorsTexture"
    );
    r.uniform1i(L, 2), r.activeTexture(r.TEXTURE2), r.bindTexture(
      r.TEXTURE_2D,
      t.cachedTilesScaleFactorsTexture
    );
  }
  setLinesProgramUniforms() {
    if (!this.viewport)
      return;
    const t = this.gl, r = this.linesProgram;
    t.useProgram(r);
    const e = t.getUniformLocation(
      r,
      "u_viewportToClipTransform"
    );
    t.uniformMatrix4fv(
      e,
      !1,
      u(this.viewport.viewportToClipTransform)
    );
    const o = t.getUniformLocation(
      r,
      "u_clipToViewportTransform"
    );
    t.uniformMatrix4fv(
      o,
      !1,
      u(z(this.viewport.viewportToClipTransform))
    );
    const i = t.getUniformLocation(
      r,
      "u_animationProgress"
    );
    t.uniform1f(i, this.animationProgress);
  }
  setLinesProgramMapUniforms(t) {
    if (!this.viewport)
      return;
    const r = this.gl, e = this.linesProgram;
    r.useProgram(e);
    const o = O(
      this.viewport.projectedGeoToClipTransform,
      t.invertedRenderTransform
    ), i = r.getUniformLocation(
      e,
      "u_renderTransform"
    );
    r.uniformMatrix4fv(
      i,
      !1,
      u(o)
    );
  }
  setPointsProgramUniforms() {
    if (!this.viewport)
      return;
    const t = this.gl, r = this.pointsProgram;
    t.useProgram(r);
    const e = t.getUniformLocation(
      r,
      "u_animationProgress"
    );
    t.uniform1f(e, this.animationProgress);
  }
  setPointsProgramMapUniforms(t) {
    if (!this.viewport)
      return;
    const r = this.gl, e = this.pointsProgram;
    r.useProgram(e);
    const o = O(
      this.viewport.projectedGeoToClipTransform,
      t.invertedRenderTransform
    ), i = r.getUniformLocation(
      e,
      "u_renderTransform"
    );
    r.uniformMatrix4fv(
      i,
      !1,
      u(o)
    );
  }
  startTransformationTransition(t) {
    for (const r of this.warpedMapList.getWarpedMaps(t)) {
      if (!this.viewport)
        break;
      r.updateVertexBuffers(
        this.viewport.projectedGeoToClipTransform
      );
    }
    this.lastAnimationFrameRequestId !== void 0 && cancelAnimationFrame(this.lastAnimationFrameRequestId), this.animating = !0, this.transformationTransitionStart = void 0, this.lastAnimationFrameRequestId = requestAnimationFrame(
      ((r) => this.transformationTransitionFrame(r, t)).bind(
        this
      )
    );
  }
  transformationTransitionFrame(t, r) {
    if (this.transformationTransitionStart || (this.transformationTransitionStart = t), t - this.transformationTransitionStart < b)
      this.animationProgress = (t - this.transformationTransitionStart) / b, this.renderInternal(), this.lastAnimationFrameRequestId = requestAnimationFrame(
        ((e) => this.transformationTransitionFrame(e, r)).bind(
          this
        )
      );
    else {
      for (const e of this.warpedMapList.getWarpedMaps(r)) {
        if (e.resetPrevious(), !this.viewport)
          break;
        e.updateVertexBuffers(
          this.viewport.projectedGeoToClipTransform
        );
      }
      this.animating = !1, this.animationProgress = 0, this.transformationTransitionStart = void 0, this.changed();
    }
  }
  changed() {
    this.dispatchEvent(new m(T.CHANGED));
  }
  imageInfoLoaded(t) {
    t instanceof m && this.dispatchEvent(new m(T.IMAGEINFOLOADED));
  }
  clearMap(t) {
    const r = this.warpedMapList.getWarpedMap(t);
    r && r.clearTextures();
  }
  mapTileLoaded(t) {
    if (t instanceof m) {
      const { mapId: r, tileUrl: e } = t.data, o = this.tileCache.getCacheableTile(e);
      if (!o || !o.isCachedTile())
        return;
      const i = this.warpedMapList.getWarpedMap(r);
      if (!i)
        return;
      i.addCachedTileAndUpdateTextures(o);
    }
  }
  mapTileRemoved(t) {
    if (t instanceof m) {
      const { mapId: r, tileUrl: e } = t.data, o = this.warpedMapList.getWarpedMap(r);
      if (!o)
        return;
      o.removeCachedTileAndUpdateTextures(e);
    }
  }
  warpedMapAdded(t) {
    if (t instanceof m) {
      const r = t.data, e = this.warpedMapList.getWarpedMap(r);
      e && this.addEventListenersToWebGL2WarpedMap(e);
    }
  }
  preChange(t) {
    if (t instanceof m) {
      const r = t.data;
      for (const e of this.warpedMapList.getWarpedMaps(r))
        this.animating && e.mixPreviousAndNew(1 - this.animationProgress);
    }
  }
  transformationChanged(t) {
    if (t instanceof m) {
      const r = t.data;
      this.startTransformationTransition(r);
    }
  }
  distortionChanged(t) {
    if (t instanceof m) {
      const r = t.data;
      this.startTransformationTransition(r);
    }
  }
  addEventListenersToWebGL2WarpedMap(t) {
    t.addEventListener(
      T.TEXTURESUPDATED,
      this.throttledChanged.bind(this)
    );
  }
  removeEventListenersFromWebGL2WarpedMap(t) {
    t.removeEventListener(
      T.TEXTURESUPDATED,
      this.throttledChanged.bind(this)
    );
  }
  contextLost() {
    this.disableRender = !0, this.cancelThrottledFunctions();
    for (const t of this.warpedMapList.getWarpedMaps())
      t.cancelThrottledFunctions();
    this.tileCache.clear();
  }
  contextRestored() {
    this.initializeWebGL(this.gl), this.disableRender = !1;
  }
}
export {
  ft as default
};
//# sourceMappingURL=WebGL2Renderer.js.map
